import { jsx as _jsx } from "react/jsx-runtime";
import { isMemberRewardFilmAdvanceBookingPeriod, NotificationType } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isPast, isToday } from 'date-fns';
import { observer } from 'mobx-react';
import { useOccContext } from '../../../../context/occ/hooks/use-occ-context';
import { NotificationUI } from '../../../../subcomponents/notification/subcomponents/ui';
const b = bemClassBuilder('v-film-advance-booking-period-notification');
export const FilmAdvanceBookingPeriodNotificationUI = observer(props => {
    const { i18n, assets: { advanceBookingPeriodNotificationIconName }, displayText: { member: memberDisplayText } } = useOccContext();
    const { id, bookingPeriod, displayText, templateParameters } = props;
    const { messageFormat, todayMessageFormat } = displayText;
    if (!bookingPeriod)
        return null;
    const startDate = new Date(bookingPeriod.startsAt);
    if (isPast(startDate))
        return null;
    const template = isToday(startDate) ? todayMessageFormat : messageFormat;
    const message = i18n.template(template, Object.assign(Object.assign({}, templateParameters), { startsAt: bookingPeriod.startsAt }));
    const title = isMemberRewardFilmAdvanceBookingPeriod(bookingPeriod)
        ? memberDisplayText.rewardExclusiveLabel
        : undefined;
    return (_jsx(NotificationUI, { id: id, type: NotificationType.Error, title: title, messages: [message], iconName: advanceBookingPeriodNotificationIconName, wrapperClassName: b.block() }));
});
FilmAdvanceBookingPeriodNotificationUI.displayName = 'FilmAdvanceBookingPeriodNotificationUI';
